import { QuestionBase } from './question-base.model';

export class RangeQuestion extends QuestionBase<string> {
    controlType = 'range';
    type: string;
    resource: any;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
        this.resource = options['resource'] || [];
    }
}